<template>
  <div class="py-6!">
    <div class="flex flex-wrap gap-3 justify-between bg-zinc-200 p-3 rounded-xl sticky top-28 z-10">
      <UInput
        v-model="searchQuery"
        placeholder="Search courses..."
        size="lg"
        class="flex-1 min-w-0 max-w-lg"
        clearable
        icon="mdi:magnify"
      />
      <div class="flex gap-3">
        <USelectMenu
          v-model="selectedLevel"
          :items="courseLevelOptions"
          placeholder="Filter by Level"
          multiple
          clear
          icon="mdi:filter-outline"
          class="w-full max-w-54"
        />
        <USelectMenu
          v-model="selectedAudience"
          :items="audienceOptions"
          placeholder="Filter by Audience"
          multiple
          icon="mdi:filter-outline"
          clear
          class="w-full max-w-54"
        />
      </div>
    </div>
    <TransitionGroup
      name="list"
      tag="div"
      class="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8"
    >
      <CourseDirectoryCard v-for="course in filteredCourses" :key="course.id" :course="course" />
    </TransitionGroup>
  </div>
</template>

<script setup lang="ts">
const { fetchAllCourses } = useCourse()
const { getCourseLevelOptions, getAudienceOptions, filterCourses } = useCourseDirectoryFilters()

const courses = ref<CoursesRecord[]>()
const searchQuery = ref('')
const selectedLevel = ref<string[]>([])
const selectedAudience = ref<string[]>([])

const courseLevelOptions = computed(() => {
  return getCourseLevelOptions(courses.value)
})

const audienceOptions = computed(() => {
  return getAudienceOptions(courses.value)
})

onMounted(async () => {
  courses.value = await fetchAllCourses()
})

const filteredCourses = computed(() => {
  return filterCourses(
    courses.value,
    searchQuery.value,
    selectedLevel.value,
    selectedAudience.value
  )
})
</script>

<style scoped>
.list-enter-active,
.list-leave-active {
  transition: all 0.3s ease;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

.list-move {
  transition: transform 0.3s ease;
}
</style>
